<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-title"><span class="part-num">PART I</span><br/>Clearing Your Path to Retirement</h1>
<p class="part-intro">Before you decide what specific path you’d like to take in your retirement, we need to go over some basic concepts. If you’ve read other retirement books, including my <i>The 5 Years Before You Retire</i> (shameless plug!), you may be familiar with some of this material. However, it never hurts to go over it again.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?65eecac2